var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('step-progress',_vm._b({staticClass:"subject-progress",attrs:{"ratio":_vm.ratio,"totalStep":_vm.totalStep,"currentStep":_vm.currentStep,"stepLabels":_vm.stepLabels}},'step-progress',_vm.progressStyle,false))}
var staticRenderFns = []

export { render, staticRenderFns }